/**
 * Hierarchical query keys for cockpit personalization (#7, Domain 4).
 *
 * The data is per-USER (the server scopes by session), so the keys carry no
 * user/tenant id — one bars list and one state object per signed-in user.
 * Bar/item mutations invalidate `bars()`; the recall mutation invalidates
 * `state()`. Logout clears the whole query client (frontend-conventions),
 * so a next user never sees the previous user's cached bars.
 */
export const cockpitQueryKeys = {
  all: ['cockpit'] as const,
  /** The user's favorite trial bars with expanded items. */
  bars: () => [...cockpitQueryKeys.all, 'trial-bars'] as const,
  /** The last-trial recall (`{ lastTrialId }`). */
  state: () => [...cockpitQueryKeys.all, 'state'] as const,
};
